import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ClinicId } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface RefillTreatmentParams {
  treatmentId: string
  clinicId: ClinicId
  patientId: string
}

/** Creates a new refill order for an existing treatment at current product pricing. */
export function useRefillTreatment() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ treatmentId, clinicId }: RefillTreatmentParams) => {
      const response = await api.post('/treatments/:id/refill', {
        params: { id: treatmentId },
        body: { clinicId },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: (_data, { patientId }) => {
      queryClient.invalidateQueries({ queryKey: ['patient-treatments', patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', patientId] })
      queryClient.invalidateQueries({ queryKey: ['orders'] })
      queryClient.invalidateQueries({ queryKey: ['patient-orders', patientId] })
    },
  })
}
